module.exports = __webpack_public_path__ + "static/tvOS+TV-d0d44f6e6876d77aabef432dd0504d47.png";